module.exports = __webpack_public_path__ + "static/media/exit-left-arrow.11246984.svg";